import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "datepicker-header",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: [
    "./datepicker-header.css"
  ],
  templateUrl: "./datepicker-header.html"
})
export class DatepickerHeaderComponent {

  @Input() label: string;
  @Input() isDisabled: boolean;

  @Output() change = new EventEmitter();
  @Output() prev = new EventEmitter();
  @Output() next = new EventEmitter();

}
